;(function () {
	let swiperBenefits = null

	const initSlider = (slider) => {
		if (!slider) return

		const btnPrev = slider.querySelector('.benefits__button-prev')
		const btnNext = slider.querySelector('.benefits__button-next')
		const isAutoplay = slider.getAttribute('data-autoplay') === 'true'
		const autoplayDelay = slider.getAttribute('data-autoplay-delay') || 3
		const slidesPerViewDesktop = parseInt(slider.getAttribute('data-slides-per-view-desktop')) || 3
		const slidesPerGroupDesktop = parseInt(slider.getAttribute('data-slides-per-group-desktop')) || 1
		const enableLoop = slider.getAttribute('data-enable-loop') === 'true'
		const enableMobile = slider.getAttribute('data-enable-mobile') === 'true'
		const enableDesktop = slider.getAttribute('data-enable-desktop') === 'true'

		// Calculate slides per view for different breakpoints
		const desktopSlides = slidesPerViewDesktop
		const desktopGroup = slidesPerGroupDesktop
		const tabletSlides = Math.min(Math.ceil(desktopSlides / 2), desktopSlides)
		const tabletGroup = Math.min(desktopGroup, tabletSlides)
		const mobileSlides = 1
		const mobileGroup = 1

		// Build breakpoints configuration
		const breakpoints = {}
		
		// Mobile (always 1 slide if mobile slider is enabled)
		if (enableMobile) {
			breakpoints[320] = {
				slidesPerView: mobileSlides,
				slidesPerGroup: mobileGroup,
				spaceBetween: 0,
			}
		}

		// Tablet breakpoint
		if (enableDesktop && tabletSlides > 1) {
			breakpoints[750] = {
				slidesPerView: tabletSlides,
				slidesPerGroup: tabletGroup,
				spaceBetween: 16,
			}
		}

		// Desktop breakpoint
		if (enableDesktop) {
			breakpoints[991] = {
				slidesPerView: desktopSlides,
				slidesPerGroup: desktopGroup,
				spaceBetween: 16,
			}
		}

		swiperBenefits = new Swiper(slider, {
			loop: enableLoop,
			slidesPerView: enableDesktop ? desktopSlides : mobileSlides,
			slidesPerGroup: enableDesktop ? desktopGroup : mobileGroup,
			spaceBetween: enableDesktop ? 16 : 0,
			breakpoints: breakpoints,
			navigation: {
				nextEl: btnNext,
				prevEl: btnPrev,
			},
			autoplay: isAutoplay ? {
				delay: autoplayDelay * 1000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			} : false,
		})
	}

	const destroySlider = () => {
		if (swiperBenefits) {
			swiperBenefits.destroy(true, true)
			swiperBenefits = null
		}
	}

	const shouldInitSlider = (width, slider) => {
		if (!slider) return false

		const enableMobile = slider.getAttribute('data-enable-mobile') === 'true'
		const enableDesktop = slider.getAttribute('data-enable-desktop') === 'true'

		// If desktop slider is enabled, always show slider
		if (enableDesktop) return true

		// Otherwise, only show on mobile if mobile slider is enabled
		if (enableMobile && width < 991) return true

		return false
	}

	const initBenefits = () => {
		const benefitsSection = document.querySelector('.benefits-section')
		if (!benefitsSection) return

		const slider = benefitsSection.querySelector('.swiper--benefits')
		if (!slider) return

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries
			const width = entry.contentRect.width

			if (shouldInitSlider(width, slider)) {
				if (!swiperBenefits) {
					initSlider(slider)
				}
			} else {
				if (swiperBenefits) {
					destroySlider()
				}
			}
		})

		sectionResizeObserver.observe(benefitsSection)

		// Initialize on load if needed
		const currentWidth = benefitsSection.offsetWidth
		if (shouldInitSlider(currentWidth, slider)) {
			initSlider(slider)
		}
	}

	// Initialize on page load
	initBenefits()

	// Handle Shopify theme editor events
	document.addEventListener('shopify:section:load', function (event) {
		if (event.target.classList.contains('benefits-section')) {
			if (swiperBenefits) {
				destroySlider()
			}
			// Use setTimeout to ensure DOM is ready
			setTimeout(() => {
				initBenefits()
			}, 100)
		}
	})

	document.addEventListener('shopify:section:unload', function (event) {
		if (event.target.classList.contains('benefits-section')) {
			if (swiperBenefits) {
				destroySlider()
			}
		}
	})
})()

